/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM, createNamespace } from 'src/util/bem';
import './gis.less';
import GisSider from './component/gisSider';
import alertInfoWindow from './component/infoWindow';
import { StationListDOI } from '../stationList/api/stationListApi';
import EnmuCommunicationStatus from 'src/enums/enmuCommunicationStatus';
import Switch from 'src/types/iview/Switch';
import { getStationIcon } from 'src/components/stationTree/stationTree';
import EnumStationType from 'src/enums/enumStationType';
import EnumDeviceStatus from 'src/enums/enumDeviceStatus';
import Bus, { Events } from 'src/util/bus';
import PublicApi from 'src/util/publicApi';
import { applyOfficialMapStyle, applyTdtTheme, createHtmlOverlay, createLngLat, createMarkerIcon, createPixelPoint, ensureTianDiTuLoaded, getT } from 'src/util/tianditu';

let bem = createBEM('gis');

export const MARK_SIZE = {
    width: 20,
    height: 26,
};

const GIS_POPUP_WIDTH = 623;
const GIS_POPUP_HEIGHT = 451;
const GIS_POPUP_OFFSET_Y = 500;
const ACTIVE_MARK_SIZE = {
    width: 32,
    height: 40,
};

@Component
export default class Gis extends Vue.Component<any> {
    map: any;
    offlineCount: number = 0;
    onlineCount: number = 0;
    showName: boolean = false;
    nameSetted: boolean = false;
    zoomNum = 0;
    stations: ReadonlyArray<StationListDOI.RowDataI> = [];
    cancelAnimate: any;
    markers!: any;
    switchShow: boolean = true;
    nameLabels: any[] = [];
    currentPopupOverlay: any = null;
    currentPopupVm: any = null;
    activeMarkerRestore: any = null;

    handleDocumentClick = (event: MouseEvent) => {
        let target = event.target as HTMLElement | null;
        if (!target) {
            return;
        }
        if (target.closest('.gis-popup__close')) {
            this.resetActiveMarker();
        }
    };

    setInfoWindow(marker: any, data: StationListDOI.RowDataI) {
        let t = this;
        marker.addEventListener('click', function() {
            t.openMark(marker, data);
        });
    }

    resetActiveMarker() {
        if (this.currentPopupVm && typeof this.currentPopupVm.$destroy === 'function') {
            this.currentPopupVm.$destroy();
        }
        this.currentPopupVm = null;
        if (this.currentPopupOverlay) {
            this.currentPopupOverlay.remove();
        }
        this.currentPopupOverlay = null;
        if (this.cancelAnimate) {
            this.cancelAnimate();
            this.cancelAnimate = null;
        }
        if (this.map) {
            this.map.enableScrollWheelZoom();
        }
    }

    openMark(marker: any, data: StationListDOI.RowDataI) {
        this.resetActiveMarker();
        this.map.disableScrollWheelZoom();
        let point = data.location_point.split(',');
        let popupId = 'gis-popup-' + data.id + '-' + Date.now();
        this.currentPopupOverlay = createHtmlOverlay(this.map, {
            lngLat: createLngLat(point[0], point[1]),
            className: 'gis-popup',
            offsetX: -(GIS_POPUP_WIDTH / 2),
            offsetY: -GIS_POPUP_OFFSET_Y,
            pointerEvents: true,
            html: `<div class="gis-popup__panel"><div class="gis-popup__close">×</div><div id="${popupId}" class="gis-popup__content"></div></div>`,
        });
        this.currentPopupVm = alertInfoWindow(popupId, data);
        this.cancelAnimate = this.setMarkAnimate(data);
    }

    async initMap() {
        let t = this;
        let TMap = await ensureTianDiTuLoaded();
        let map = new TMap.Map('container');
        this.map = map;
        applyTdtTheme('container');
        map.enableScrollWheelZoom();
        map.centerAndZoom(createLngLat(116.404, 39.915), 12);
        applyOfficialMapStyle(map, 'indigo');
        map.addEventListener('zoomend', function() {
            t.zoomNum = map.getZoom();
            t.changeNameStatus();
        });
    }

    init(data: StationListDOI.RowDataI[]) {
        let TMap = getT();
        let points: any[] = [];
        let offlineCount = 0;
        let onlineCount = 0;
        this.stations = Object.freeze(data);
        let markers: any = {};
        this.map.clearOverLays();
        this.resetActiveMarker();
        this.clearNameLabels();
        data.forEach(i => {
            if (i.device_status === EnmuCommunicationStatus.OffLine.getId()) {
                offlineCount++;
            } else {
                onlineCount++;
            }
            let point = i.location_point.split(',');
            let lngLat = createLngLat(point[0], point[1]);
            points.push(lngLat);
            let marker = new TMap.Marker(lngLat, {
                icon: this.getStationIcon(i),
            });
            markers[i.id] = marker;
            this.setInfoWindow(marker, i);
            this.map.addOverLay(marker);
        });
        this.markers = markers;
        this.offlineCount = offlineCount;
        this.onlineCount = onlineCount;
        if (points.length) {
            this.map.setViewport(points);
        }
        this.queryStatus();
    }

    getStationIcon(data: StationListDOI.RowDataI) {
        return createMarkerIcon(getStationIcon(data), MARK_SIZE.width, MARK_SIZE.height);
    }

    setMarkAnimate(data: StationListDOI.RowDataI) {
        let marker = this.markers[data.id];
        if (!marker) {
            return () => undefined;
        }
        let iconUrl = getStationIcon(data);
        let animatedSvg = encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="${ACTIVE_MARK_SIZE.width}" height="${ACTIVE_MARK_SIZE.height}" viewBox="0 0 ${ACTIVE_MARK_SIZE.width} ${ACTIVE_MARK_SIZE.height}">
                <style>
                    .pulse { animation: pulse 0.8s infinite; transform-origin: ${ACTIVE_MARK_SIZE.width / 2}px ${ACTIVE_MARK_SIZE.height - 2}px; }
                    @keyframes pulse {
                        0% { transform: scale(1); }
                        50% { transform: scale(1.18); }
                        100% { transform: scale(1); }
                    }
                </style>
                <image class="pulse" href="${iconUrl}" x="${(ACTIVE_MARK_SIZE.width - MARK_SIZE.width) / 2}" y="${ACTIVE_MARK_SIZE.height - MARK_SIZE.height}" width="${MARK_SIZE.width}" height="${MARK_SIZE.height}"/>
            </svg>
        `);
        let animatedIcon = createMarkerIcon(`data:image/svg+xml;charset=UTF-8,${animatedSvg}`, ACTIVE_MARK_SIZE.width, ACTIVE_MARK_SIZE.height);
        let normalIcon = createMarkerIcon(iconUrl, MARK_SIZE.width, MARK_SIZE.height);
        marker.setIcon(animatedIcon);
        return () => {
            marker.setIcon(normalIcon);
        };
    }

    clearNameLabels() {
        this.nameLabels.forEach(i => i.remove());
        this.nameLabels = [];
    }

    async changeNameStatus() {
        if (this.showName && !this.nameSetted) {
            this.stations.forEach(i => {
                let point = i.location_point.split(',');
                this.nameLabels.push(createHtmlOverlay(this.map, {
                    lngLat: createLngLat(point[0], point[1]),
                    className: 'gis-site-name',
                    offsetX: 0,
                    offsetY: -(MARK_SIZE.height + 12),
                    html: '<span class="gis-site-name__text">' + i.name + '</span>',
                }));
            });
            this.nameSetted = true;
        }
        if (!this.showName && this.nameSetted) {
            this.clearNameLabels();
            this.nameSetted = false;
        }
    }

    clickMark(data: StationListDOI.RowDataI) {
        let marker = this.markers[data.id];
        if (!marker) {
            return;
        }
        if (typeof marker.getLngLat === 'function') {
            this.map.panTo(marker.getLngLat());
        }
        this.openMark(marker, data);
    }

    async queryStatus() {
        let {code, data} = await PublicApi.getSiteStatus();
        if (code === 0) {
            this.showName = (data.is_show_sitename === 1);
            this.changeNameStatus();
        }
    }

    async mounted() {
        await this.initMap();
        document.addEventListener('click', this.handleDocumentClick, true);
        Bus.$on(Events.GISStationClick, this.clickMark);
    }

    beforeDestroy() {
        document.removeEventListener('click', this.handleDocumentClick, true);
        this.resetActiveMarker();
        Bus.$off(Events.GISStationClick, this.clickMark);
    }

    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('side')}>
                    <GisSider on-init={this.init.bind(this)} />
                </div>
                <div class={bem('content')}>
                    <div class={bem('status-bar')}>
                        {'\u5728\u7ebf\uff1a'}<span class={createNamespace('mr10')} style="color:#02fb71">
                            {this.onlineCount}
                        </span>
                        {'\u79bb\u7ebf\uff1a'}<span class={createNamespace('mr10')} style="color:#cccccc">
                            {this.offlineCount}
                        </span>
                        {'\u8054\u7f51\u7387\uff1a'}<span class={createNamespace('mr10')} style="color:#fd8713">
                            {~~((this.onlineCount / (this.onlineCount + this.offlineCount)) * 100) + '%'}
                        </span>
                        {'\u603b\u6570\uff1a'}<span class={createNamespace('mr10')} style="color:#1ea4dd">
                            {this.onlineCount + this.offlineCount}
                        </span>
                    </div>
                    <div class={bem('legend-wrapper')}>
                        <div class={bem('show-name')}>
                            <div v-if={this.switchShow} style="display: inline-block;">
                                {'\u7ad9\u70b9\u540d\u79f0\u663e\u793a'}
                                <Switch v-model={this.showName} size="large" on-on-change={() => {
                                    PublicApi.setSiteStatus(this.showName ? 1 : 2);
                                    this.changeNameStatus();
                                }}>
                                    <span slot="open">ON</span>
                                    <span slot="close">OFF</span>
                                </Switch>
                            </div>
                            <span class={`wqms-font icon-shuangcengjian ${!this.switchShow ? 'mirror' : ''}`} on-click={() => this.switchShow = !this.switchShow}/>
                        </div>
                        <div class={bem('legend')}>
                            <div class={bem('legend-bar')}>{'\u56fe\u4f8b'}</div>
                            <div class={bem('legend-title')}>{'\u7ad9\u70b9\u72b6\u6001'}</div>
                            <div class={bem('legend-status')}>
                                <div>{'\u6b63\u5e38'}</div>
                                <div>{'\u79bb\u7ebf'}</div>
                                <div>{'\u6545\u969c'}</div>
                            </div>
                            <div class={bem('legend-sign')}>
                                <div>
                                    {'\u6c61\u67d3\u6e90\u76d1\u6d4b\u7ad9\uff1a'}<img src={getStationIcon({type: EnumStationType.Pollution.getId(), device_status: EnumDeviceStatus.Normal.getId()})} />
                                </div>
                                <div>
                                    {'\u5730\u8868\u6c34\u76d1\u6d4b\u7ad9\uff1a'}<img src={getStationIcon({type: EnumStationType.Water.getId(), device_status: EnumDeviceStatus.Normal.getId()})} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="container" style="height:calc(100% + 25px)" />
                </div>
            </div>
        );
    }
}
